import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IGroupParams, IGroupResponse, IGroupState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchCreateGroup = createAsyncThunk(
  'listGroups/fetchCreateGroup',
  async (params: IGroupParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createGroup(params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IGroupState = {
  isLoading: false,
  response: null,
  error: null
}

const createGroupSlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetCreateGroup: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateGroup.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchCreateGroup.fulfilled, (state, action: PayloadAction<IGroupResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchCreateGroup.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default createGroupSlice.reducer
export const { resetCreateGroup } = createGroupSlice.actions
